import type { Interceptor } from '@connectrpc/connect'
import { getBrowserLocation } from '@repo/env-graphql-url'
import { rpcUrlForLocation } from '@repo/env-graphql-url/rpc-connect-url'

export const proxyInterceptor: Interceptor = next => req => {
  return next({ ...req, url: rpcUrlForLocation(req.url, getBrowserLocation()) })
}
